import styled from '@emotion/styled';
import {motion} from 'framer-motion';
import {Position, TooltipType} from './tooltip';

interface WrapperProps {
  position?: Position;
}

export const Wrapper = styled(motion.div)<WrapperProps>`
  position: absolute;
  bottom: 0.625em;
  pointer-events: none;
  transform: translate(-50%, -50%);

  ${({position}) => {
    switch (position) {
      case 'center': {
        return `
          left: 50%;
        `;
      }
      default: {
        return `
          left: ${position};
        `;
      }
    }
  }}
`;

interface ContainerProps {
  type: TooltipType;
  offset: number;
}

export const Container = styled.div<ContainerProps>`
  border-radius: 4px;
  background: ${({type}) =>
    type === 'info' ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.9)'};
  transform: translate(calc(-50% - ${({offset}) => offset}px));
`;

export const Label = styled.p`
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  padding: 0.25em 1.5em;
  gap: 0.625em;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;
